import { render } from "./YearSelect.vue?vue&type=template&id=74bf0779&scoped=true"
import script from "./YearSelect.vue?vue&type=script&lang=js"
export * from "./YearSelect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bf0779"]])

export default __exports__